import { render } from "./PageRangeBikou.vue?vue&type=template&id=792b5a8e&scoped=true"
import script from "./PageRangeBikou.vue?vue&type=script&lang=js"
export * from "./PageRangeBikou.vue?vue&type=script&lang=js"

import "./PageRangeBikou.vue?vue&type=style&index=0&id=792b5a8e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792b5a8e"]])

export default __exports__